import {
  INICIO_RECUPERAR_SENHA,
  RECUPERAR_SENHA,
  RECUPERAR_SENHA_SUCESSO,
  RECUPERAR_SENHA_FALHA,
  INICIO_RECUPERAR_SENHA_SUCESSO,
  INICIO_RECUPERAR_SENHA_FALHA,
  ON_SHOW_LOADER,
  INIT_URL,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_ERROR_MESSAGE,
} from "constants/ActionTypes";

const INIT_STATE = {
  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  senha: '',
  confirmarSenha: '',
  token: '',
  bearer: '',
  trocaSenhaSucesso: false,
  trocaSenhaExpirada: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIO_RECUPERAR_SENHA: {
      return {
        ...state,
        edicao: false,
        loader: true,
        carregandoLista: true,
      }
    }
    case INICIO_RECUPERAR_SENHA_SUCESSO: {
      return {
        ...state,
        loader: false,
        bearer: action.payload.token
      }
    }
    case RECUPERAR_SENHA: {
      return {
        ...state,
        ...action.payload
      }
    }
    case INICIO_RECUPERAR_SENHA_FALHA: {
      return {
        ...state,
        trocaSenhaExpirada: true
      }
    }
    case RECUPERAR_SENHA_SUCESSO: {
      return {
        ...state,
        loader: false,
        trocaSenhaSucesso: true
      }
    }
    case RECUPERAR_SENHA_FALHA: {
      return {
        ...state,
        edicao: false,
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      }
    }
    default:
      return state;
  }
}